<app-new-roof-cost-header></app-new-roof-cost-header>

<div class="nrc-page__hero-and-trust">
  <app-new-roof-cost-banner
    [fetchedZipcode]="fetchedZipcode"
    [zipValue]="zipVal"
    (zipValueChange)="zipVal = $event"
  ></app-new-roof-cost-banner>
  <section class="nrc-page__trust">
    <app-new-roof-cost-trust-signals></app-new-roof-cost-trust-signals>
  </section>
</div>
<div class="nrc-page__content">
  <app-new-roof-cost-how-it-works
    [step1ZipCode]="fetchedZipcode"
    (step1Click)="onStep1Click()"
  ></app-new-roof-cost-how-it-works>
  <app-new-roof-cost-calculator></app-new-roof-cost-calculator>
  @if (isBrowser) {
    <app-new-roof-cost-certifications></app-new-roof-cost-certifications>
  }
  @if (isBrowser) {
    <app-new-roof-cost-testimonials></app-new-roof-cost-testimonials>
  }
  <app-new-roof-cost-promo-banner [fetchedZipcode]="fetchedZipcode"></app-new-roof-cost-promo-banner>
  <app-new-roof-cost-footer></app-new-roof-cost-footer>
</div>
